export class RouteConfig {
    static readonly DEFAULT_ROUTE_COLOR = '#29ABE2';
    static readonly DEFAULT_ROUTE_WIDTH = 8;
    static readonly SELECTED_ROUTE_WIDTH = 12;
    static readonly WIDTH_ROUTE_MARGIN = 2;
    static readonly DEFAULT_Z_INDEX = 1;
    static readonly SELECTED_Z_INDEX = 10;
}
